import web3 from 'web3'

const user = {
  state: {
    accountAddress: '',
    isAdmin: false,
    userData: {
      level: 0,
    },
  },

  getters: {
    accountAddress: (state) => state.accountAddress,
    isWalletConnected: (state) => Boolean(state.accountAddress),
    isAdmin: (state) => state.isAdmin,
  },

  mutations: {
    SET_ADDRESS: (state, address) => {
      state.accountAddress = address || ''
    },
    CLEAR_ADDRESS: (state) => {
      state.accountAddress = ''
      state.isAdmin = false
    },
    SET_USERDATA: (state, userData) => {
      state.userData = userData
    },
    SET_ADMIN_STATUS: (state, isAdmin) => {
      state.isAdmin = Boolean(isAdmin)
    },
  },

  actions: {},
}

export default user
